import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Grid } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as Email from "email-validator";
import Password from "../common/password-validator";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(1),
  },
}));

const AddOrUpdateUser = (props) => {
  const classes = useStyles();
  const {
    handleButtonClick,
    action,
    handleUserChange,
    addAnother,
    handleAddAnother,
    loading,
  } = props;

  const defaultPartner = { id: 0, name: "Choose a Partner" };
  const defaultUserRole = { id: 0, name: "Choose a User Role" };

  let { partners, userRoles } = props;

  partners = [defaultPartner, ...partners];
  userRoles = [defaultUserRole, ...userRoles];

  const initialState = {
    user: {},
    selectedPartner: defaultPartner,
    selectedUserRole: defaultUserRole,
  };

  const [state, setState] = useState(initialState);

  const { user, selectedPartner, selectedUserRole } = state;

  const {
    userRole,
    partner,
    active,
    password,
    password2,
    is_admin,
    email,
    first_name,
    last_name,
    phone_number,
    updatePassword,
  } = user;

  const isEmpty = (data) => {
    let response = true;
    if (data) {
      response = false;
    }
    return response;
  };

  const checkPassword = updatePassword
    ? Password.validate(password) &&
      Password.validate(password2) &&
      password === password2
    : true;

  const isValidData =
    checkPassword &&
    !isEmpty(userRole) &&
    !isEmpty(partner) &&
    Email.validate(email) &&
    !isEmpty(first_name) &&
    !isEmpty(last_name) &&
    !isEmpty(phone_number);

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const user = { ...state.user, [name]: value };
    setState((prevState) => ({
      ...prevState,
      user,
    }));
  };

  useEffect(() => {
    const { user } = props;
    user.updatePassword = action === "Add" ? true : user?.updatePassword;
    user.userRole =
      action === "Update" ? user?.userrole?.roleID : user?.userRole;
    user.partner = action === "Update" ? user?.partnerID : user?.partner;

    const selectedPartner = partners.filter(
      (partner) => partner.id === props?.user?.partner
    )[0];

    const selectedUserRole = userRoles.filter(
      (userRole) => userRole.id === props?.user?.userRole
    )[0];

    setState((prevState) => ({
      ...prevState,
      user,
      selectedPartner: selectedPartner ?? defaultPartner,
      selectedUserRole: selectedUserRole ?? defaultUserRole,
    }));
  }, [props.user]);

  return (
    <div>
      <Dialog
        open={!(action === "Close") && !loading}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <DialogTitle style={{ padding: "0px" }}>
          <Grid container justify="flex-end">
            <IconButton
              onClick={() => {
                handleButtonClick(`Close`);
              }}
            >
              <CloseIcon style={{ fill: "red" }} />
            </IconButton>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <b>{action} User</b>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>

        
        <DialogContent style={{ padding: "0px" }}>
          <div className={classes.root}>
            <Paper className={classes.paper}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    error={isEmpty(first_name)}
                    helperText={isEmpty(first_name) ? "Required." : ""}
                    margin="dense"
                    name="first_name"
                    id="first_name"
                    label="First Name"
                    type="text"
                    onChange={handleInput}
                    value={first_name ?? ""}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    error={isEmpty(last_name)}
                    helperText={isEmpty(last_name) ? "Required." : ""}
                    margin="dense"
                    name="last_name"
                    id="last_name"
                    label="Last Name"
                    type="text"
                    onChange={handleInput}
                    value={last_name ?? ""}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    error={!Email.validate(email)}
                    helperText={!Email.validate(email) ? "Invalid." : ""}
                    margin="dense"
                    name="email"
                    id="email"
                    label="Email"
                    type="text"
                    onChange={handleInput}
                    value={email ?? ""}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <TextField
                    error={isEmpty(phone_number)}
                    helperText={isEmpty(phone_number) ? "Required." : ""}
                    margin="dense"
                    name="phone_number"
                    id="phone_number"
                    label="Phone Number"
                    type="number"
                    onChange={handleInput}
                    value={phone_number ?? 254}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(partner)}>
                    <Autocomplete
                      autoFocus
                      options={partners}
                      value={selectedPartner}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { user } = state;
                          user.partner = newValue.id;
                          const selectedPartner = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            user,
                            selectedPartner,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Partner"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(partner) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl error={isEmpty(userRole)}>
                    <Autocomplete
                      autoFocus
                      options={userRoles}
                      value={selectedUserRole}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      style={{ width: 200 }}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const { user } = state;
                          user.userRole = newValue.id;
                          const selectedUserRole = newValue;
                          setState((prevState) => ({
                            ...prevState,
                            user,
                            selectedUserRole,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="User Role"
                          variant="standard"
                        />
                      )}
                    />
                    {isEmpty(userRole) && (
                      <FormHelperText>Required.</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={is_admin ?? false}
                        onChange={(event) => {
                          setState((prevState) => ({
                            ...prevState,
                            user: {
                              ...user,
                              is_admin: event.target.checked,
                            },
                          }));
                        }}
                        name="is_admin"
                        color="primary"
                      />
                    }
                    label="Is Admin"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={active ?? false}
                        onChange={(event) => {
                          setState((prevState) => ({
                            ...prevState,
                            user: {
                              ...user,
                              active: event.target.checked,
                            },
                          }));
                        }}
                        name="active"
                        color="primary"
                      />
                    }
                    label="Is Active"
                  />
                </Grid>
              </Grid>
              {updatePassword && (
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      error={!Password.validate(password)}
                      helperText={
                        !Password.validate(password)
                          ? "Password must be, length 8 - 100, at least one special character, uppercase letter, lowercase letter, 2 digits and no spaces."
                          : ""
                      }
                      margin="dense"
                      name="password"
                      id="password"
                      label="Password"
                      type="password"
                      onChange={handleInput}
                      value={password ?? ""}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      error={
                        !Password.validate(password2) ||
                        !(password === password2)
                      }
                      helperText={
                        !Password.validate(password2) ||
                        !(password === password2)
                          ? "Required, must match the first password."
                          : ""
                      }
                      margin="dense"
                      name="password2"
                      id="password2"
                      label="Retype Password"
                      type="password"
                      onChange={handleInput}
                      value={password2 ?? ""}
                      fullWidth
                      required
                    />
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
        </DialogContent>


        <DialogActions style={{ padding: "0px" }}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs>
              {action === "Update" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={updatePassword ?? false}
                      onChange={(event) => {
                        setState((prevState) => ({
                          ...prevState,
                          user: {
                            ...user,
                            updatePassword: event.target.checked,
                          },
                        }));
                      }}
                      name="updatePassword"
                      color="primary"
                    />
                  }
                  label="Update Password"
                />
              )}
              {action === "Add" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={addAnother}
                      onChange={handleAddAnother}
                      name="addAnother"
                      color="primary"
                    />
                  }
                  label="Add another"
                />
              )}
            </Grid>

            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <Button
                    onClick={() => {
                      handleButtonClick(`Close`);
                    }}
                    color="primary"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  {(action === "Add" || action === "Update") && (
                    <Button
                      onClick={() => {
                        handleUserChange(user);
                      }}
                      color="primary"
                      variant="outlined"
                      disabled={!isValidData}
                    >
                      {action}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AddOrUpdateUser;
